import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * - `empty`: the source has no rows at all.
 * - `no-results`: rows exist, but the current search or filters hide every one.
 * - `error`: the fetch failed.
 */
export type PtlTableEmptyKind = 'empty' | 'no-results' | 'error';

/** The body of `ptl-data-table` when there are no rows to show. */
@Component({
  selector: 'ptl-table-empty',
  templateUrl: './ptl-table-empty.component.html',
  styleUrls: ['./ptl-table-empty.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PtlTableEmptyComponent {
  @Input() kind: PtlTableEmptyKind = 'empty';
  @Input() emptyTitle = '';
  @Input() emptyDescription = '';
  @Input() errorReference = '';
  @Input() compact = false;

  @Output() clearFilters = new EventEmitter<void>();
  @Output() retry = new EventEmitter<void>();
}
